/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import { useEffectOnce } from '@/hooks';
import queryString from 'query-string';
import CloseIcon from '@mui/icons-material/Close';
import Skeleton from '@mui/material/Skeleton';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import {
  BPReviewPanel, DhgateReviewItemList, DhgateReviewPanel,
  ReviewItemList, RAReviewPanel, EmailContact,
} from '@components';
import {
  Tabs, Tab, Stack, Button, Stepper, Step, StepLabel, StepContent,
} from '@mui/material';
import { ClaimType, PLATFORM_NAME, dhgate } from '@constants';
import InfoTip from '@assets/info-tip.svg';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useEffect } from 'react';
import classes from './index.module.css';
import useFeedback from './hooks';
import Loading from './loading';
import { isUserMobile } from '../../utils';
import TrackingForm from './TrackingForm';

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const statusMap = {
  'In Progress': 'progress',
  Accepted: 'accepted',
  Rejected: 'rejected',
};
const RA_SUBMIT_TIPS = ['1. Make sure your return item is in its original condition and package the item. ', '2. Download shipping label and secure the label to the outside of your package.'];
const drawerBleeding = 56;

// const testDownloadLink = 'https://deliver.goshippo.com/ae4f41c72b654f02bc2d3f35f8961a7a.png?Expires=1692100945&Signature=KBLO00N5t8nPKcmpJNbZm-KjD8PHmWbNNG1dwO4ILKzPk1V2uW8EcTO6XBLRHbZsDAW~zHKnUeN4wPQ9MM5erTav22p24X96~blPNae~KG6pN1-PvnihY6hy-sMV5ydFAS1Qi-zbmytUaNJyYayJr32GGc7JsRBafI5mRCIDBS5T-iMqUd637e3sW2w47EWeuAvhfFHEhhsEpiYL~P3rgiochGW87DnIhCYJz4KakEd21NDV2UmEQAmVYcWuL86CnIKIELO70WRK6hW0ycQokWjejcKn5br6lvKaECT47W1gKaRtXKD4IaUOvAqKX~Ms9q7xxXzckf3sxIQByCL9KQ__&Key-Pair-Id=APKAJRICFXQ2S4YUQRSQ';

export const Feedback = () => {
  const {
    platform, tabIndex, list, detailInfo, isLoading, open, policyId, claimList, toggleDrawer, getFeedbackList, onChange, reportIssueClick, handleSubmit,
  } = useFeedback();
  const {
    history, items: fulfilledItems, estimatedRefund = {}, issueTypeCode: issueType, attachments, status, issueTypeDesc, trackingNumber, comment, shippingMethod, carrier,
  } = detailInfo;
  const isMobile = isUserMobile();
  const ReviewPanel = () => {
    if (platform === dhgate) {
      return (
        <DhgateReviewPanel
          reviewInfo={estimatedRefund}
        />
      );
    } if (![ClaimType.EW, ClaimType.AD].includes(issueType) && (issueType === ClaimType.RA)) {
      return (
        <RAReviewPanel reviewInfo={{ ...estimatedRefund, shippingOnOwn: shippingMethod === 'ship_on_their_own' }}>
          <section className={classes.reported_line}>
            <section>Shipping Protection</section>
            <section className={classes.reported_money}>{estimatedRefund.shippingInsuranceFee || '--'}</section>
          </section>
        </RAReviewPanel>
      );
    }

    return (
      <BPReviewPanel
        reviewInfo={estimatedRefund}
      />
    );
  };

  useEffectOnce(() => {
    const url = window.location.href;
    const { claimId } = queryString.parse(url?.split('?')[1]);
    getFeedbackList(claimId, 0);
  }, []);

  useEffect(() => {
    const script = document.createElement('script');
    let timeId = null;
    if (status) {
      // 添加typeform记录用户反馈
      script.src = '//embed.typeform.com/next/embed.js';
      script.name = 'typeform';
      timeId = setTimeout(() => {
        document.body.appendChild(script);
      }, 5000);
    }
    return () => {
      clearTimeout(timeId);
      script?.remove();
      document.querySelector('.tf-v1-popover')?.remove();
    };
  }, [status]);
  if (isLoading) {
    return <Loading />;
  }
  const TabsPart = ({ claimIdList = [] }) => (
    <Tabs
      orientation="vertical"
      sx={{
        width: isMobile ? '100%' : '300px',
        textTransform: 'none',
        '& .MuiTabs-indicator': {
          display: 'flex',
          backgroundColor: '#645AFF',
          height: '30px !important',
          width: '4px',
          left: 0,
          marginTop: '9px',
        },
        '& .MuiTab-root': {
          textTransform: 'none',
          padding: '8PX 16PX',
        },
      }}
      value={tabIndex}
      onChange={onChange}
    >
      {claimIdList?.map((tab, index) => (
        <Tab
          key={tab.claimId}
          label={(
            <div className={classes.tabItem}>
              {tab.claimId}
              <div className={`${classes.status} ${classes[statusMap[tab.status]]}`}>{tab.status}</div>
            </div>
          )}
          {...a11yProps(index)}
        />
      ))}
    </Tabs>
  );

  const renderToReturn = ({ downloadLink, dropOffLocation, qrCode }) => {
    const isG2 = shippingMethod === 'use_g2_label';
    return (
      <div>
        <div className={classes.ra_submit_title}>Your return request has been submitted, it’s time to ship back the item!</div>
        <div className={classes.ra_submit}>
          {RA_SUBMIT_TIPS.map((v) => <div key={v}>{v}</div>)}
          {isG2 ? (
            <div>
              {'3. Visit your nearest '}
              <a href={dropOffLocation} target="_blank" rel="noreferrer">
                {carrier}
                {' '}
                location
              </a>
              {' to drop off your return within '}
              <span className={classes.bold}>3</span>
              {' days.'}
            </div>
          ) : (
            <div>
              {'3. Visit your nearest '}
              <a href="https://tools.usps.com/find-location.htm" target="_blank" rel="noreferrer">USPS location</a>
              {' to drop off your return within '}
              <span className={classes.bold}>3</span>
              {' days or '}
              <a href="https://tools.usps.com/schedule-pickup-steps.htm" target="_blank" rel="noreferrer">schedule a pickup</a>
              {' with USPS.'}
            </div>
          )}
        </div>
        {status !== 'Rejected'
          && (
            <div className={classes.shipping}>
              {downloadLink && (
              <Button
                sx={{
                  backgroundColor: '#FFFFFF',
                  '&:hover': {
                    backgroundColor: '#F6F6F7',
                  },
                  '& a': {
                    color: '#fff',
                    textDecoration: 'none',
                    padding: '2px 8px',
                  },
                }}
                className={classes.shippingLabelBtn}
              >
                {/* Download shipping label */}
                <a href={downloadLink} target="_blank" rel="noopener noreferrer" download>Download shipping label</a>
              </Button>
              )}
              {qrCode && (
              <Button
                sx={{
                  backgroundColor: '#FFFFFF',
                  '&:hover': {
                    backgroundColor: '#F6F6F7',
                  },
                  '& a': {
                    color: '#fff',
                    textDecoration: 'none',
                    padding: '2px 8px',
                  },
                }}
                className={classes.shippingLabelBtn}
              >
                <a href={qrCode} target="_blank" rel="noopener noreferrer" download>QR Code</a>
              </Button>
              )}
              {dropOffLocation && (
              <Button
                sx={{
                  backgroundColor: '#FFFFFF',
                  '&:hover': {
                    backgroundColor: '#F6F6F7',
                  },
                  '& a': {
                    color: '#fff',
                    textDecoration: 'none',
                    padding: '2px 8px',
                  },
                }}
                className={classes.shippingLabelBtn}
              >
                <a href={dropOffLocation} target="_blank" rel="noopener noreferrer" download>Drop off locations</a>
              </Button>
              )}
            </div>
          )}

      </div>
    );
  };
  const currentTab = list.find((v) => v.claimId === detailInfo.claimId);
  return (
    <div className={classes.wrapper}>
      {isMobile ? (
        <>
          <div className={classes.mobile_header}>
            <div className={classes.tabs_header}>Reported Issues</div>

            {!!claimList.length && (
              <Button
                className={classes.issueButton}
                onClick={reportIssueClick}
              >
                Report an issue

              </Button>
            )}
          </div>
          <div onClick={toggleDrawer(true)} className={classes.currentTab_title}>
            <div className={classes.current_item}>
              <span className={classes.current_indicator}></span>
              <span>{currentTab?.claimId}</span>

              <div className={`${classes.status} ${classes[statusMap[currentTab?.status]]}`}>{currentTab?.status}</div>
            </div>
            <ArrowDropDownIcon className={classes.dropdown_icon} />
          </div>

          <SwipeableDrawer
            anchor="bottom"
            open={open}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}
            swipeAreaWidth={drawerBleeding}
            disableSwipeToOpen={false}
            ModalProps={{
              keepMounted: true,
            }}
            className={classes.drawer_content}
          >
            <div className={classes.drawer_content}>
              <div className={classes.tabs_header}>Reported Issues</div>
              <TabsPart claimIdList={list} />

            </div>

            <Skeleton variant="rectangular" height="100%" />
          </SwipeableDrawer>
        </>
      ) : (
        <>
          <div style={{ width: '351PX', visibility: 'hidden', minWidth: '300PX' }}></div>
          <Stack direction="column" style={{ position: 'fixed', height: '100%' }}>
            <div className={classes.tabs_header}>Reported Issues</div>
            <div className={classes.tab_part}>
              <TabsPart claimIdList={list} />

              {!!claimList.length && (
                <Button
                  className={classes.issueButton}
                  onClick={reportIssueClick}
                >
                  Report an issue

                </Button>
              )}
            </div>

          </Stack>
        </>
      )}

      <Stack
        direction="column"
        sx={{
          width: isMobile ? '100%' : '80%',
          alignItems: 'center',
          position: 'realative',
          zIndex: 11,
          paddingRight: !isMobile && '100px',
          textAlign: 'left',
        }}
      >
        <div className={classes.card}>
          <div className={classes.detailTitle}>Issue progress</div>
          <Stepper
            // activeStep={1}
            orientation="vertical"
            sx={{
              '& .MuiStepIcon-root': {
                width: '32PX',
                height: '32PX',
                color: '#D4D4D4',
              },
            }}
          >
            {history?.map(({
              done, title, desc, eventTime, downloadLink, dropOffLocation, qrCode,
            }) => {
              const showRejectIcon = done && title === 'Rejected';
              return (
                <Step
                  key={title}
                  completed={done}
                  expanded={done}
                  active={done}
                  sx={{
                    '& .MuiStepContent-root, & + .MuiStepConnector-root .MuiStepConnector-line': {
                      borderLeft: `2px solid  ${done ? '#738DED' : '#D5D5D5'}`,
                      paddingLeft: '28px',
                    },
                    '& .MuiStepContent-root, & + .MuiStepConnector-root': {
                      marginLeft: '14PX',
                    },
                    '& .MuiStepContent-last': {
                      borderLeft: 'none',
                    },
                    '& .MuiStepIcon-root.Mui-completed': {
                      color: title === 'Accepted' ? '#59CD9E' : '#738DED',
                    },
                  }}
                >
                  <StepLabel
                    StepIconComponent={showRejectIcon ? CloseIcon : null}
                    sx={{
                      '& .MuiSvgIcon-root': showRejectIcon ? {
                        color: '#fff',
                        background: '#FFA343',
                        borderRadius: '50%',
                        width: '32PX',
                        height: '32PX',
                      } : {},
                    }}
                  >
                    <div className={classes.stepLabelWrapper}>
                      <span className={classes.stepTitle}>{title}</span>
                      {eventTime && (
                        <span className={classes.stepTime}>
                          {`${eventTime} (UTC)`}
                        </span>
                      )}
                    </div>
                  </StepLabel>
                  <StepContent
                    sx={{
                      '&': {
                        wordBreak: 'break-word',
                      },
                    }}
                  >
                    {issueType === ClaimType.RA && title === 'Submitted' ? (
                      <div>
                        {downloadLink
                          ? renderToReturn({ downloadLink, dropOffLocation, qrCode })
                          : (
                            <TrackingForm trackingNumber={trackingNumber} status={status} desc={desc} handleSubmit={handleSubmit} />
                          )}
                        {(!trackingNumber || downloadLink) && status === 'In Progress' && (
                          <div className={classes.tip_wrapper}>
                            <img src={InfoTip} alt="" />
                            Please make sure to ship your return in 7 days, otherwise your return request will be rejected.
                          </div>
                        )}
                      </div>
                    )
                      // eslint-disable-next-line react/no-danger
                      : <div className={classes.stepContent} dangerouslySetInnerHTML={{ __html: desc }}></div>}
                  </StepContent>
                </Step>
              );
            })}
          </Stepper>

        </div>
        {ReviewPanel()}
        {platform === dhgate ? (
          <DhgateReviewItemList
            infoList={detailInfo}
            files={attachments?.map((item) => ({ name: item.originalFileName }))}
            type={issueType}
            comments={comment}
            issueTypeDesc={issueTypeDesc}
            orderNameTitleText={platform === PLATFORM_NAME.SIDELINESWAP ? 'Swap' : 'Order'}
          />
        ) : (
          <ReviewItemList
            selectedPackageList={fulfilledItems}
            files={attachments?.map((item) => ({ name: item.originalFileName }))}
            type={issueType}
            comments={comment}
            issueTypeDesc={issueTypeDesc}
            orderNameTitleText={platform === PLATFORM_NAME.SIDELINESWAP ? 'Swap' : 'Order'}
          />
        )}
        <div className={classes.bottomMark}>
          {EmailContact}
        </div>
      </Stack>

      {/* 添加typeform记录用户反馈  https://seel.atlassian.net/browse/OP-2205 */}
      <div id="typeform" data-tf-popover="JIXHLspS" data-tf-custom-icon="https://images.typeform.com/images/zBPgAKMtjwxA" data-tf-opacity="100" data-tf-iframe-props="title=Share your valuable feedback and help us improve!" data-tf-open="time" data-tf-open-value="3000" data-tf-auto-close data-tf-transitive-search-params data-tf-button-color="#645AFF" data-tf-tooltip="Share your valuable feedback and help us improve!" data-tf-medium="snippet" data-tf-hidden={`utm_content=${policyId}`} style={{ all: 'unset' }}></div>
      {/* <script src="//embed.typeform.com/next/embed.js"></script> */}
    </div>
  );
};
